var path = 'app/components/ordinacija/ordinacijaCreateEdit.html';
var html = "<header id=\"header\"></header><navbar id=\"menu\"></navbar><div id=\"wrapper\"><page-header icon=\"vm.icon\" page-title=\"vm.pageTitle\" page-desc=\"vm.pageDesc\"></page-header><div class=\"content\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"hpanel\"><div class=\"panel-heading\"></div><div class=\"panel-body\"><ordinacija-form fields=\"vm.fields\" on-submit=\"vm.submit(item)\" item=\"vm.item\"></ordinacija-form></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/ordinacija/ordinacijaCreateEdit.html
// module id = 580
// module chunks = 0